import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Col, FormGroup, Label, CustomInput } from '@polichat/flamboyant';

import WabaService from '../../../../../../services/tools/template-waba/template-waba'
import { useGlotaT, useGlotaLocale } from 'src/hooks/useGlotaTranslation';
import glotaTranslationService from 'src/services/glota-translation.service';

function SelectCategoryWaba({ onUpdate , initialValue , isEdit }) {
  const categoryLabel = useGlotaT('spa.messageBuilder.category.label');
  const categoryUtilities = useGlotaT('spa.messageBuilder.category.utilities');
  const categoryMarketing = useGlotaT('spa.messageBuilder.category.marketing');
  const categoryAuthentication = useGlotaT('spa.messageBuilder.category.authentication');
  const { currentLocale } = useGlotaLocale();

  // Traduz o título de uma subcategoria a partir do identificador estável (fui).
  // Faz fallback para o título original vindo do backend caso não haja tradução.
  const translateSubcategory = (category) => {
    if (!category?.fui) {
      return category?.title;
    }
    const key = `spa.messageBuilder.category.subcategories.${category.fui}`;
    const translated = glotaTranslationService.translateSync(key, {}, currentLocale);
    return translated === key ? category.title : translated;
  };
  const customer_id = useSelector((state) => state.general.current_customer_id);
  const [categoriesList, setCategoriesList] = useState([]);
  const [categoryType, setCategoryType] = useState({});

  useEffect(()=>{
    async function fetchCategoriesWaba() {
      const result = await WabaService.getWabaCategories({ customer_id });
      if(result){
        setCategoriesList(result);
        setCategoryType({
          category: initialValue !== 'none' ? initialValue : result[0].id
        });
        initialValue === 'none' && handleCategoryData({
          category: result[0].id
        })
      }
    }
    fetchCategoriesWaba();
  },[])

  const handleInputsChange = ({target: {name, value}}) => {
    setCategoryType({
      [name]: Number(value),
    });
    handleCategoryData({
      [name]: Number(value),
    });
  }

  const handleCategoryData = (data) => {
    onUpdate(data);
  }

  const utility = categoriesList.filter(category => category.group === 'UTILITY')
  const marketing = categoriesList.filter(category => category.group === 'MARKETING')
  const authentication = categoriesList.filter(category => category.group === 'AUTHENTICATION')

  return (
    <Col sm={12} md={6}>
      <FormGroup>
        <Label>{categoryLabel}</Label>
        <CustomInput
          type="select"
          id="waba-category"
          name="category"
          value={categoryType.category}
          onChange={handleInputsChange}
          required
          disabled={isEdit}
        >
          <optgroup label={categoryUtilities}>
          {utility?.map(category => (
              <option key={category.id} value={category.id}>
                {translateSubcategory(category)}
              </option>
          ))}
          </optgroup>
          <optgroup label={categoryMarketing}>
          {marketing?.map(category => (
              <option key={category.id} value={category.id}>
                {translateSubcategory(category)}
              </option>
          ))}
          </optgroup>
          <optgroup label={categoryAuthentication}>
          {authentication?.map(category => (
              <option key={category.id} value={category.id}>
                {translateSubcategory(category)}
              </option>
          ))}
          </optgroup>
        </CustomInput>
      </FormGroup>
    </Col>
  );
}

export default SelectCategoryWaba;
